import { TKwikUIInputSize, VKwikUIInputSize } from "./input-slider.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isNumber = (x: number) => typeof x === "number";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    id: isString,
    invalid: isBoolean,
    label: isString,
    max: isNumber,
    min: isNumber,
    placeholder: isString,
    postfix: isString,
    prefix: isString,
    quantum: isNumber,
    size: (x: TKwikUIInputSize) => VKwikUIInputSize.includes(x),
    steps: isNumber,
    type: isString
  };

  return methods[key] && methods[key](value);
};
